var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useDispatch } from 'react-redux';
import { isEqual } from 'lodash';
import { updateWidget } from 'app/store/reducers/widgets';
import { updateDashboardWidgets } from 'app/store/reducers/dashboardWidgets';
import { getResources } from 'app/store/selectors/getResources';
import FormData from 'app/components/Form/FormData/FormData.jsx';
import { ModalConfirmForm } from 'app/components/Modal';
import { getParentWidget, getWidgetChildsRecursively, getWidgetConfigRecursively, isOneParentSupervisor, } from 'app/pages/Project/Settings/Dashboards/utils';
import formFields from 'app/pages/Project/Settings/Dashboards/ModalEditWidget/formFields';
const ModalEditWidget = (_a) => {
    var { projectId, widget, allWidgets } = _a, modalprops = __rest(_a, ["projectId", "widget", "allWidgets"]);
    const dispatch = useDispatch();
    const stepProjects = getResources(undefined, 'steps');
    const parentWidget = getParentWidget(widget.id, allWidgets);
    const { assetType, steps } = getWidgetConfigRecursively({ widget, widgets: allWidgets, keys: ['assetType', 'steps'] });
    const oneParentIsSupervisor = isOneParentSupervisor(widget.id, allWidgets);
    const fields = formFields({
        widget,
        stepProjects,
        oneParentIsSupervisor,
        parentWidget: parentWidget,
    });
    const handleUpdateWidget = (data) => __awaiter(void 0, void 0, void 0, function* () {
        const { name, isSupervisor, assetType, steps } = data;
        const widgetRel = { id: widget.rel_dashboardWidgetInst.id, isSupervisor };
        const widgetChilds = getWidgetChildsRecursively(widget, allWidgets);
        const widgetsChildsRel = widgetChilds.map((widget) => ({ id: widget.rel_dashboardWidgetInst.id, isSupervisor }));
        const stepsIds = steps === null || steps === void 0 ? void 0 : steps.map((step) => step.value);
        const config = {
            assetType,
            steps: stepsIds,
        };
        // we exclude episodes from parent widget config because we don't nedd it here
        const parentWidgetConfig = { assetType: parentWidget === null || parentWidget === void 0 ? void 0 : parentWidget.config.assetType, steps: parentWidget === null || parentWidget === void 0 ? void 0 : parentWidget.config.steps };
        const updatedWidget = {
            id: widget.id,
            config: isEqual(config, parentWidgetConfig) ? widget.config : config,
            name,
        };
        const requests = [...widgetsChildsRel, widgetRel];
        const promises = [
            dispatch(updateWidget({ updatedWidget, refetchData: false })),
            dispatch(updateDashboardWidgets(requests)),
        ];
        const res = yield Promise.all(promises);
        return res;
    });
    return (_jsx(ModalConfirmForm, Object.assign({ draggable: false, title: `Edit widget ${widget.widgetType === 'container' ? 'group' : ''}`, validateLabel: "Save" }, modalprops, { children: _jsx(FormData, { onSave: (data) => __awaiter(void 0, void 0, void 0, function* () {
                const res = yield handleUpdateWidget(data);
                return res;
            }), defaultData: {
                name: widget === null || widget === void 0 ? void 0 : widget.name,
                isSupervisor: (widget === null || widget === void 0 ? void 0 : widget.rel_dashboardWidgetInst.isSupervisor) || oneParentIsSupervisor,
                assetType: assetType,
                steps: steps === null || steps === void 0 ? void 0 : steps.map((stepId) => ({
                    label: stepProjects[stepId].name,
                    value: stepProjects[stepId].id,
                })),
            }, properties: fields, flashNotifSuccessLabel: "Widget updated" }) })));
};
export default ModalEditWidget;
